import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './project.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './config/tracing';
import '@ford/ford-design-system/dist/web-components.cjs';

const root = ReactDOM.createRoot(document.getElementById('root'));

/* root.render(
  <React.StrictMode>
   
     <Misc/>         
     
  </React.Str
  ictMode>
); */

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
